import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}
const emsOnboardIntitutes = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.bulkEMSOnboardInstitutes),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      institutionId: data.institutionId.toString(),
      name: data.name.toString(),
    },
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { emsOnboardIntitutes }
